import { ReactNode } from 'react';

import { Box, Button, Flex, Text } from '@chakra-ui/react';

import { ReactComponent as LogoIcon } from 'icons/logo.svg';
import Sponsor from 'components/home/AuthHome/Sponsor';

interface TutorialProps {
  title: ReactNode;
  content: ReactNode;
  onOk?: () => void;
}

const Tutorial = ({ onOk, title, content }: TutorialProps) => {
  return (
    <Box
      px="24px"
      pt="8px"
      position="fixed"
      top="0"
      left="0"
      w="100%"
      h="100%"
      zIndex={99}
      background="rgba(36,36,36,0.96)"
    >
      <Flex
        alignItems="center"
        justifyContent="center"
        flexDirection="column"
        h="100%"
        maxW="500px"
        gap="32px"
        mx="auto"
      >
        {/* <LogoIcon width="40px" height="40px" /> */}
        {title}
        {content}
        <Button data-cy="close-game-tutorial" minW="150px" onClick={onOk}>
          got it
        </Button>
        <Flex>
          {/* <Sponsor /> */}
        </Flex>
      </Flex>
    </Box>
  );
};

export default Tutorial;
